import { render } from "./invite-talent-modal.vue?vue&type=template&id=0a2f3173&ts=true"
import script from "./invite-talent-modal.vue?vue&type=script&lang=ts"
export * from "./invite-talent-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__